module.exports = __webpack_public_path__ + "img/fox.bc00bce9.svg";